<template>
  <!-- Distintivo de fuente/responsable de un campo. `short` usa la versión corta (CM/PM) para cabeceras de columna.
       La clase va prefijada con `sc-` para que ningún token (field, table...) colisione con Bulma/Tailwind. -->
  <span class="src-chip" :class="'sc-' + source" v-tip="tipText">{{ label }}</span>
</template>

<script>
  import { tip } from '../shared/tip'

  export default {
    name: 'PrmSummarySourceChip',

    directives: { tip },

    props: {
      // Fuentes reales (azul): admin | medic | planif | prm | fact | contract | incid | resumen | calc | auto.
      // Responsables manuales (ámbar): cm | pm | field. Sin fuente: none.
      source: { type: String, required: true },
      tipOverride: { type: String, default: '' }, // tooltip a medida (si no, el genérico de la fuente)
      short: { type: Boolean, default: false },    // etiqueta corta (CM/PM/Auto) para cabeceras de columna
    },

    computed: {
      // Etiqueta del chip: corta (cabeceras de columna) o completa (cabeceras de sección / campos).
      label () {
        const base = 'prm_summary_src_' + this.source
        return this.short ? this.$t(base + '_short') : this.$t(base)
      },
      // Los campos SIN FUENTE no llevan tooltip; el resto sí (el nombre completo del responsable).
      tipText () {
        if (this.source === 'none') return ''
        return this.tipOverride || this.$t('prm_summary_src_' + this.source + '_tip')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .src-chip {
    display: inline-block; margin-left: 6px; font-size: 9px; font-weight: 700;
    text-transform: uppercase; letter-spacing: .03em; padding: 1px 5px; border-radius: 3px;
    white-space: nowrap; vertical-align: middle;
  }
  .src-chip:not(.sc-none) { cursor: help; }
  // Fuentes reales / calculadas: distintivo azul.
  .src-chip.sc-admin, .src-chip.sc-medic, .src-chip.sc-planif, .src-chip.sc-prm, .src-chip.sc-fact, .src-chip.sc-contract, .src-chip.sc-incid, .src-chip.sc-resumen, .src-chip.sc-calc, .src-chip.sc-auto {
    background: #e7effb; color: #2b5cad; border: 1px solid #c3d5f2;
  }
  // Manual (sin fuente o responsable de cumplimentar): ámbar punteado.
  .src-chip.sc-none, .src-chip.sc-cm, .src-chip.sc-pm, .src-chip.sc-field { background: #fff4d6; color: #8a6d00; border: 1px dashed #e0b52a; }
</style>
